<template>
  <component
    :is="tooltip.length ? 'stzh-tooltip' : 'div'"
    :content="tooltip"
    :size="tooltipSize"
    :placement="tooltipPlacement">
    <stzh-button
      :id="id"
      :disabled="disabled"
      rel="noopener noreferrer"
      :variant="variant"
      :label="value"
      :icon="icon"
      :size="size"
      :href="href"
      :target="target"
      :fullwidth="fullWidth"
      :icon-only="iconOnly"
      :no-padding-left="noPaddingLeft"
      @stzhClick="$emit('stzhClick')" />
  </component>
</template>

<script>
export default {
  name: 'StzhButtonComponent',
  props: {
    value: {
      type: String,
      required: true,
    },
    tooltip: {
      type: String,
      default: '',
    },
    tooltipSize: {
      type: String,
      default: 'default',
    },
    tooltipPlacement: {
      type: String,
      default: 'top-start',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      default: 'default',
    },
    icon: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: 'default',
    },
    noPaddingLeft: {
      type: Boolean,
      default: false,
    },
    href: {
      type: String,
      default: '',
    },
    target: {
      type: String,
      default: '_blank',
    },
    iconOnly: {
      type: Boolean,
      default: false,
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 800px) {
  ::v-deep .sc-stzh-button-s.sc-stzh-button-h {
    width: 100% !important;
  }
}
</style>
